import { render } from "./qiankun.vue?vue&type=template&id=3559a2f8&scoped=true"
import script from "./qiankun.vue?vue&type=script&lang=js"
export * from "./qiankun.vue?vue&type=script&lang=js"

import "./qiankun.vue?vue&type=style&index=0&id=3559a2f8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3559a2f8"

export default script